﻿import { createFileRoute } from "@tanstack/react-router";
import { DadosVendasPage } from "@/paginas/pg_franquia/franquia-analises-dados-vendas";

export const Route = createFileRoute("/_authenticated/franquia-analises-dados-vendas")({
  head: () => ({
    meta: [
      { title: "Dados de vendas — Milky Moo Palmares" },
      { name: "description", content: "Visualize e exporte dados de vendas." },
      { property: "og:title", content: "Dados de vendas — Milky Moo Palmares" },
    ],
  }),
  component: DadosVendasPage,
});
